"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const alpinejs_1 = __importDefault(require("alpinejs"));
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
require("swiper/css/pagination");
require("swiper/swiper-bundle.css");
alpinejs_1.default.data("contactForm_General", () => {
    return {
        data: {
            token: "",
            type: "",
            nome: "",
            cognome: "",
            provincia: "",
            email: "",
            attachment: null,
            messaggio: "",
            privacy: false,
        },
        validationErrors: {
            token: false,
            type: false,
            nome: false,
            cognome: false,
            provincia: false,
            email: false,
            attachment: false,
            messaggio: false,
            privacy: false,
        },
        controlData: {
            token: { required: false },
            type: { required: true },
            nome: { required: true },
            cognome: { required: true },
            provincia: { required: true },
            email: { required: true },
            attachment: { required: false },
            messaggio: { required: true },
            privacy: { required: true },
        },
        sent: false,
        result: false,
        loading: false,
        send: "",
        submit(token) {
            this.data.token = token;
            for (let k in this.data) {
                if (typeof this.data[k] === "boolean") {
                    if (this.controlData[k].required === true) {
                        if (!this.data[k]) {
                            this.validationErrors[k] = true;
                        }
                        else {
                            this.validationErrors[k] = false;
                        }
                    }
                }
                else {
                    if ((this.data[k] === "" || this.data[k] === null) &&
                        this.controlData[k].required === true) {
                        this.validationErrors[k] = true;
                    }
                    else {
                        this.validationErrors[k] = false;
                    }
                }
                if (Object.values(this.validationErrors).every((i) => i === false)) {
                    const formData = new FormData();
                    formData.append("action", "form_submit");
                    for (let k in this.data) {
                        if (typeof this.data[k] === "boolean")
                            formData.append(k, this.data[k] ? "1" : "0");
                        else
                            formData.append(k, this.data[k]);
                    }
                    if (this.sent || this.loading)
                        return;
                    this.loading = true;
                    fetch("/wp-admin/admin-ajax.php", {
                        method: "POST",
                        credentials: "same-origin",
                        body: formData,
                    })
                        .then(() => {
                        window.dataLayer.push({
                            event: "generate_lead",
                            form_type: "contact-us",
                        });
                        this.result = true;
                        this.sent = true;
                        this.loading = false;
                    })
                        .catch(() => {
                        this.result = false;
                        this.sent = false;
                        this.error = true;
                        this.errorDetail = "EEE";
                    })
                        .finally(() => {
                        this.loading = false;
                    });
                }
                else {
                    window.scrollTo(0, 0);
                    console.log("err");
                    this.loading = false;
                    this.sent = false;
                }
            }
        },
        resetAttachment() {
            this.data.attachment = null;
        },
    };
});
alpinejs_1.default.data("productsArchive", (grouped, defaultData) => {
    return {
        data: {
            defaultData: defaultData ? true : false,
            productCategory: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.productCategory) || "",
            productTaste: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.productTaste) || "",
            productFormat: (defaultData === null || defaultData === void 0 ? void 0 : defaultData.productFormat) || "",
            products: [],
            searching: false,
            categories: [],
            tastes: [],
            formats: [],
            grouped: grouped ? true : false,
        },
        loading: false,
        init() {
            //this.fetchFilters();
            if (this.data.defaultData)
                this.search();
            else {
                this.data.productCategory = "";
                this.data.productTaste = "";
                this.data.productFormat = "";
            }
        },
        search() {
            return __awaiter(this, void 0, void 0, function* () {
                const _productCategory = this.data.productCategory;
                const _productTaste = this.data.productTaste;
                const _productFormat = this.data.productFormat;
                this.loading = true;
                yield this.fetchFilters();
                yield new Promise((resolve) => {
                    fetch("/wp-admin/admin-ajax.php", {
                        method: "POST",
                        credentials: "same-origin",
                        body: new URLSearchParams({
                            action: "products_archive",
                            productCategory: this.data.productCategory,
                            productTaste: this.data.productTaste,
                            productFormat: this.data.productFormat,
                            grouped: this.data.grouped ? "1" : "0",
                        }),
                    })
                        .then((res) => res.json())
                        .then((res) => {
                        this.data.products = res;
                        this.loading = false;
                        this.data.searching = true;
                        resolve(true);
                    })
                        .catch((err) => {
                        console.log(err);
                        this.loading = false;
                        resolve(false);
                    });
                });
                this.data.productCategory = _productCategory;
                this.data.productTaste = _productTaste;
                this.data.productFormat = _productFormat;
            });
        },
        fetchFilters() {
            this.loading = true;
            fetch("/wp-admin/admin-ajax.php", {
                method: "POST",
                credentials: "same-origin",
                body: new URLSearchParams({
                    action: "products_archive_filters",
                    productCategory: this.data.productCategory,
                    productTaste: this.data.productTaste,
                    productFormat: this.data.productFormat,
                }),
            })
                .then((res) => res.json())
                .then((res) => {
                const productCategoriesEl = document.getElementById("productCategories");
                const productTastesEl = document.getElementById("productTastes");
                const productFormatsEl = document.getElementById("productFormats");
                // hide all options
                if (productCategoriesEl)
                    Array.from(productCategoriesEl.querySelectorAll("option:not([default]")).map((e) => e.setAttribute("hidden", "hidden"));
                if (productTastesEl)
                    Array.from(productTastesEl.querySelectorAll("option:not([default]")).map((e) => e.setAttribute("hidden", "hidden"));
                if (productFormatsEl)
                    Array.from(productFormatsEl.querySelectorAll("option:not([default]")).map((e) => e.setAttribute("hidden", "hidden"));
                //show if needed
                if (productCategoriesEl)
                    res.categories.forEach((e) => {
                        var _a;
                        return (_a = productCategoriesEl
                            .querySelector('option[value="' + e.slug + '"]')) === null || _a === void 0 ? void 0 : _a.removeAttribute("hidden");
                    });
                if (productTastesEl)
                    res.tastes.forEach((e) => {
                        var _a;
                        return (_a = productTastesEl
                            .querySelector('option[value="' + e.slug + '"]')) === null || _a === void 0 ? void 0 : _a.removeAttribute("hidden");
                    });
                if (productFormatsEl)
                    res.formats.forEach((e) => {
                        var _a;
                        return (_a = productFormatsEl
                            .querySelector('option[value="' + e.slug + '"]')) === null || _a === void 0 ? void 0 : _a.removeAttribute("hidden");
                    });
                //also set value to element
                if (res.categories.length == 1 && productCategoriesEl)
                    productCategoriesEl.value =
                        res.categories[0].slug;
                if (res.tastes.length == 1 && productTastesEl)
                    productTastesEl.value = res.tastes[0].slug;
                if (res.formats.length == 1 && productFormatsEl)
                    productFormatsEl.value = res.formats[0].slug;
                this.loading = false;
            })
                .catch((err) => {
                console.log(err);
                this.loading = false;
            });
        },
        reset() {
            if (!this.data.defaultData)
                this.data.productCategory = "";
            this.data.productTaste = "";
            this.data.productFormat = "";
            this.search();
        },
        productsCount() {
            return Object.values(this.data.products)
                .map((e) => e.length)
                .reduce((a, b) => a + b, 0);
        },
    };
});
// @ts-ignore
window.Alpine = alpinejs_1.default;
alpinejs_1.default.start();
window.addEventListener("load", () => {
    const swipers = document.querySelectorAll(".swiper-slider");
    for (const el of Array.from(swipers)) {
        const slidesPerView = Number(el.dataset.slidesPerView || "1");
        console.log(slidesPerView, new swiper_1.default(el, {
            modules: [modules_1.Pagination],
            slidesPerView,
            loop: true,
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
        }));
    }
    const preloadTransparents = document.querySelectorAll("video.preload-transparent");
    for (const el of Array.from(preloadTransparents)) {
        if (el.offsetParent) {
            console.log(el, "play!");
            el.classList.remove("opacity-0");
            el.play();
        }
    }
});
